import { ViewportScroller } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable()
export class AppViewportScroller implements ViewportScroller {
  private _scrollableElement: HTMLElement;

  private get scrollableElement(): HTMLElement {
    return this._scrollableElement || document.documentElement;
  }

  setScrollableElement(element: HTMLElement): void {
    this._scrollableElement = element;
  }

  scrollTop(): void {
    this.scrollableElement.scrollTo(0, 0);
  }

  getScrollPosition(): [number, number] {
    return [this.scrollableElement.scrollLeft, this.scrollableElement.scrollTop];
  }

  scrollToAnchor(anchor: string): void {
    this.scrollableElement.querySelector(`#${anchor}`)?.scrollIntoView();
  }

  scrollToPosition(position: [number, number]): void {
    this.scrollableElement.scrollTo(position[0], position[1]);
  }

  setHistoryScrollRestoration(scrollRestoration: 'auto' | 'manual'): void {
    window.history.scrollRestoration = scrollRestoration;
  }

  setOffset(offset: [number, number] | (() => [number, number])): void {
    // not needed?
  }
}
